import { lazy } from 'react'

export const ReportsPageAsync = lazy(async () =>
  import('./ReportsPage.csuploads').then(({ ReportsPage }) => {
    return { default: ReportsPage }
  })
)
